import React from 'react';
import PropTypes from 'prop-types';
import {Divider, Table} from "@material-ui/core";
import TableHeaderList from "./TableHeaderList";
import TableBodyList from "./TableBodyList";
import TableFooterList from "./TableFooterList";
import TableToolbarList from "./TableToolbarList";
import ScreenDesignerListHoc from "../../../../../../../../../HocHelpers/ScreenDesignerListHoc";

const TableList = (props) => {
    const {gridProps: {hideListFooter, hideColumnHeader, hideListHeader} = {}, name} = props;
    let toolBar = document.getElementById(`listToolBar_${name}`);
    let toolBarHeight = hideListHeader ? 0 : 37;
    if (toolBar) {
        let positionInfo = toolBar.getBoundingClientRect();
        toolBarHeight = positionInfo.height;
    }
    let heightDescent = toolBarHeight + 41;
    let heightWrapper = !hideListFooter ? `calc(99% - ${heightDescent}px)` : ('auto');

    return (
        <React.Fragment>
            <TableToolbarList/>
            <Divider/>
            <div className={'tableWrapper'} style={{height: heightWrapper}}>
                <div id={`tableWrapper_${name}`}>
                    <Table stickyHeader size={"small"} id={`listTable_${name}`} style={{tableLayout: 'auto'}}>
                        {(hideColumnHeader === false || hideColumnHeader === undefined) && (
                            <TableHeaderList/>
                        )}
                        <TableBodyList/>
                    </Table>
                </div>
            </div>
            {!hideListFooter && (
                <TableFooterList/>
            )}
        </React.Fragment>
    )
};

export default ScreenDesignerListHoc(TableList);

TableList.propTypes = {
    gridProps: PropTypes.object,
    listName: PropTypes.string
};